import flatten, { unflatten } from 'flat'
import { pickBy, isUndefined, get, join, startCase, toLower, includes } from 'lodash'
import parsePlace from 'parse-google-place'
import { PATHS } from '../constants'

export const trimData = (values, pickFunc = (value) => !isUndefined(value)) => {
	return unflatten(pickBy(flatten(values), pickFunc))
}

export const parseAddress = (place) => {
	const data = parsePlace(place)
	const location = place?.geometry?.location?.toJSON()

	return {
		city: data.city,
		country: data.countryShort,
		countryShort: data?.countryShort,
		latitude: location?.lat,
		longitude: location?.lng,
		street: data?.address?.toString(),
		zipcode: data?.zipCode?.toString(),
		state: data?.stateShort,
		stateShort: data?.stateShort,
		formatted_address: place?.formatted_address,
	}
}

export const parseLocation = (data) => {
	return {
		name: data?.name,
		city: data?.name,
		country: data?.country_code,
		countryShort: data?.country_code,
		latitude: data?.latitude ? parseFloat(data?.latitude) : undefined,
		longitude: data?.longitude ? parseFloat(data?.longitude) : undefined,
		state: data?.state_code,
		stateCode: data?.state_code,
		fullAddress: data?.full_address,
	}
}

export const parseAddressToView = (address, fields = ['city', 'state']) => join(fields.map((field) => get(address, field)).filter(Boolean), ', ')

export function capitalizeFirstLetter(string) {
	if (string) {
		return string.charAt(0).toUpperCase() + string.slice(1)
	}
}

export const capitalizeEachWork = (string) => {
	if (string) {
		return string
			.split(' ')
			.map((word) => startCase(toLower(word)))
			.join(' ')
	}
	return null
}

export const returnTabItemPath = (basePath) => {
	const tabItemPath = {
		home: PATHS.care.home,
		searchJob: PATHS.care.search,
		myJob: PATHS.care.my_jobs,
	}
	const arr = [
		{
			exceptionPaths: [PATHS.care.jobs],
			target: tabItemPath.searchJob,
		},
	]
	const result = arr.find(({ exceptionPaths }) => includes(exceptionPaths, basePath))
	return result ? result.target : basePath
}
